import { useEffect } from "react";

import useSystemStore from "@store/useSystemStore";
import { UI_TRANSITION_DELAY_MS } from "@config/constants";

export function useChromeInitialization() {
  const { isAppLoading, setIsAppLoading } = useSystemStore();

  useEffect(() => {
    if (isAppLoading) {
      // Delay to give a better loading experience in the app when the user is logged in.
      setTimeout(() => setIsAppLoading(false), UI_TRANSITION_DELAY_MS);
    }
  }, [isAppLoading]);
}
